import React from 'react'
import Icon from 'components/Icon'

import './map-center-marker.pcss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index.es'

const MapCenterMarker = () => {
    return (
        <div className="map-center-marker">
            <Icon
                fa
                name="map-marker-alt"
                size="xl"
                forceSize
                color="#cc3300"
            >
                <span className="fa-layers fa-fw">
                    <FontAwesomeIcon icon="map-marker" color="white" />
                    <FontAwesomeIcon icon="map-marker-alt" color="#cc3300" />
                </span>
            </Icon>
        </div>
    )
}

export default React.memo(MapCenterMarker)
